<template>
  <div class="main tabs_main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">原料名称：</span>
        <el-input v-model="search.materialName" :size="size" clearable placeholder="请输入原料名称"></el-input>
      </div>
      <div class="header_item">
        <el-button   :size="size" icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prodlineGuName" label="生产线名称" align="center"></el-table-column>
        <el-table-column prop="realTimeStock" label="实时库存（吨）" align="center" ></el-table-column>
        <el-table-column prop="code" label="储料仓编号" align="center" ></el-table-column>
        <el-table-column prop="typeName" label="原材料类别名称" align="center" ></el-table-column>
        <el-table-column prop="bottomCap" label="预警下限（吨）" align="center" ></el-table-column>
        <el-table-column prop="iscurrency" label="是否是通用料仓" align="center" >
            <template #default="{row}">
                <div>{{row.iscurrency===0?'否':row.iscurrency===1?'是':''}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="diameter" label="直径" align="center" ></el-table-column>
        <el-table-column prop="percentage" label="库存百分比" align="center" ></el-table-column>
        <el-table-column prop="state" label="料仓状态" align="center" >
            <template #default="{row}">
                <div>{{row.state===1?'正常使用':row.state===2?'停用':''}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="stock" label="理论库存" align="center" ></el-table-column>
        <el-table-column prop="height" label="高度" align="center" ></el-table-column>
        <el-table-column prop="specification" label="规格型号" align="center" ></el-table-column>
        <el-table-column prop="materialName" label="原材料名称" align="center" ></el-table-column>
        <el-table-column prop="jieNum" label="节数" align="center" ></el-table-column>
        <el-table-column prop="linstorageName" label="生产线储料仓名称" align="center" ></el-table-column>
        <el-table-column prop="producer" label="制造商/产地" align="center" ></el-table-column>
        <el-table-column prop="safeCap" label="安全库存量（吨）" align="center" ></el-table-column>
        <el-table-column prop="capaCity" label="最大容量（单位）" align="center" ></el-table-column>
        <el-table-column prop="topCap" label="预警上限（吨）" align="center" ></el-table-column>
        <el-table-column prop="vehicleNumber" label="车牌号" align="center" ></el-table-column>
        <el-table-column prop="serialNum" label="排序序号" align="center" ></el-table-column>
        <el-table-column prop="pinCode" label="电子识别码" align="center" ></el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { changeSize } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //生产线料仓库存列表
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
    },
    methods: {
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        this.loading = true;
        this.$api.Materials.searchProductLinesInvents(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import'@/style/layout-main.scss';
</style>